module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade modal-evidencia",
    attrs: {
      "id": "modalHistoricoSla",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body"
  }, [_c('div', {
    staticClass: "filtro-historico-sla"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filtrar pesquisa",
      "label-for": "filterInput",
      "align": "center"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "margin": "10px",
      "text-align": "center"
    },
    attrs: {
      "type": "search",
      "placeholder": "Pesquise por qualquer palavra chave"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "limparPesquisaBotao",
    attrs: {
      "disabled": !_vm.filter,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Limpar pesquisa")])], 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "teste",
    attrs: {
      "striped": "",
      "hover": "",
      "items": this.$store.state.historicoSla.historicoSla,
      "filter": _vm.filter
    }
  })], 1), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico de evidências")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-421af64a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sla/modal/ModalHistoricoSla.vue
// module id = 983
// module chunks = 1